import { useRequestLicenseRedemptionsMutation } from '@sketch/gql-types'
import * as Sentry from '@sentry/browser'

export interface UseRequestLicenseRedemptionsProps {
  onError(message: string): void
}

export const useRequestLicenseRedemptions = (
  props: UseRequestLicenseRedemptionsProps
) => {
  const { onError } = props

  const [mutate, ...rest] = useRequestLicenseRedemptionsMutation({
    onCompleted: data => {
      const errors = data.requestLicenseRedemptions.licenseRedemptions.filter(
        x => x.__typename === 'LicenseRedemptionError'
      )
      if (errors.length > 0) {
        Sentry.withScope(scope => {
          scope.setExtra('errors', JSON.stringify(errors))
          Sentry.captureMessage(
            'Failed to exchange licenses when creating a workspace'
          )
        })

        onError(
          'One or more license keys could not be exchanged. Go to your Workspace settings to review and try again.'
        )
      }
    },
    onError: ({ message }) => {
      onError(message)
    },
  })

  return [
    (customerId: string, serials: string[]) =>
      mutate({ variables: { input: { customerId, serials } } }),
    ...rest,
  ] as const
}
